import { useEffect, useState } from "react";

import { OCCURRENCE_ID_QUERY_PARAM } from "@/common/helpers/ticketingOccurrence";

export const useRequestedOccurrenceId = (): string | null => {
  const [requestedOccurrenceId, setRequestedOccurrenceId] = useState<string | null>(null);

  // Read after mount only: Cloudflare caches the HTML without its query params, so SSR must not depend on them.
  useEffect(() => {
    setRequestedOccurrenceId(new URLSearchParams(window.location.search).get(OCCURRENCE_ID_QUERY_PARAM));
  }, []);

  return requestedOccurrenceId;
};
